class CartWhatsAppEmbed extends HTMLElement {
  connectedCallback() {
    this.abortController?.abort();
    this.observer?.disconnect();
    this.abortController = new AbortController();
    this.toggle = this.querySelector('[data-whatsapp-toggle]');
    this.fields = this.querySelector('[data-whatsapp-fields]');
    this.mount = this.querySelector('[data-whatsapp-embed]');
    if (!this.toggle || !this.fields || !this.mount || !/^[a-zA-Z0-9]{6}$/.test(this.dataset.formId || '')) return;

    const { signal } = this.abortController;
    this.toggle.addEventListener('change', this.handleToggle, { signal });
    window.addEventListener('klaviyoForms', this.handleFormEvent, { signal });
    this.observer = new MutationObserver(this.syncAvailability);
    this.observer.observe(this.mount, { childList: true, subtree: true });
    this.syncAvailability();
    this.handleToggle();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.observer?.disconnect();
  }

  handleFormEvent = (event) => {
    if (event.detail?.formId !== this.dataset.formId || event.detail.type !== 'embedOpen') return;
    this.syncAvailability();
  };

  syncAvailability = () => {
    const available = Boolean(this.mount.querySelector('form'));
    this.hidden = !available;
    if (!available) {
      this.toggle.checked = false;
      this.handleToggle();
    }
  };

  handleToggle = () => {
    this.fields.hidden = !this.toggle.checked;
    this.fields.inert = !this.toggle.checked;
  };
}

if (!customElements.get('cart-whatsapp-embed')) {
  customElements.define('cart-whatsapp-embed', CartWhatsAppEmbed);
}
